import { render } from "./ProductListItem.vue?vue&type=template&id=58354116&scoped=true&ts=true"
import script from "./ProductListItem.vue?vue&type=script&lang=ts"
export * from "./ProductListItem.vue?vue&type=script&lang=ts"

import "./ProductListItem.vue?vue&type=style&index=0&id=58354116&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58354116"]])

export default __exports__